<template>
  <div
    class="group-param-page fullscreen-fixed flex-center"
    :style="{'background-color': 'transparent'}"
  >
    <div class="group-param-page__container">
      <div
        v-if="$store.groupElements"
        class="group-param-page__caption"
        :style="{color: $store.registratorCaptionColor}"
      >
        {{ 'registrator_fill_form' | translate }}
      </div>
      <div v-if="$store.groupElements" :style="{zoom: 0.5}">
        <GroupParamMobileElement
          v-for="(el, index) in $store.groupElements"
          :key="index"
          :is-active="index === currentParamIndex"
          :element="el"
          @focus="changeSelectedParam(index)"
          :value="el.data"
          @input="updateElementValue(index, $event)"
        />
        <div class="group-param-button">
          <div class="button-container">
            <button
              class="button-confirm"
              :style="{
                color: $store.registrator_text_btn,
                backgroundColor: $store.registratorBackgroundBtnColor,
              }"
               @click="onClickFinish"
            >
              {{ 'registrator_button_next' | translate }}
            </button>
            <button
              class="button-cancel"
              :style="{ color: $store.registratorCaptionColor }"
              @click="onClickCancel"
            >
              {{ 'd_ws_button_cancel' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GroupParamMobileElement from './GroupParamMobileElement';

import { GROUP_PARAMS_ERRORS } from "@/components/devices/Registrator/config";


export default {
  name: 'GroupParamsMobilePage',
  components: {GroupParamMobileElement},
  data() {
    return {
      lang: this.$store.activeLanguage,
      caps: false,
      shift: true,
      currentParamIndex: 0
    };
  },
  beforeDestroy() {
    this.$groupParamsService.reset();
  },
  methods: {
    changeSelectedParam(index) {
      if (index > this.$store.groupElements.length - 1) {
        throw new Error("Can't select next param");
      }

      this.currentParamIndex = index;
    },
    updateElementValue(index, value) {
      if (this.$store.groupElements && this.$store.groupElements[index]) {
        this.$store.groupElements[index].data = value;
      }
    },
    onClickCancel() {
      this.$emit('cancel');
    },
    onClickFinish() {
      const validation = this.$groupParamsService.validateGroupParams();
      if (validation.error) {
        this.showError(validation);
      } else {
        this.$emit('complete');
      }
    },
    formatMessage(template, values = {}) {
      return template.replace(/{(\w+)}/g, (_, key) => {
        return key in values ? values[key] : `{${key}}`;
      });
    },
    showError(validation) {
      const paramName = this.getParamTranslation(validation.invalidElement);
      const translation = this.$languageService.translateFilter(`registrator_group_param_${validation.error}`);
      const length = validation.error === GROUP_PARAMS_ERRORS.MAX_LENGTH_ERROR
        || validation.error === GROUP_PARAMS_ERRORS.MIN_LENGTH_ERROR
        ? validation.invalidElement : ''
      const formatedErrorMessage = this.formatMessage(translation, { min: length.min_length - 1, max: length.length })
      const errorMessage = `${paramName}: ${formatedErrorMessage}`
      this.$root.$emit('showModal', { message: errorMessage });
    },
    getParamTranslation(element) {
      return element.kiosk_title[this.$store.activeLanguage] || Object.values(element.kiosk_title).find(val => val);
    }
  }
};
</script>

<style lang="scss" scoped>
.group-param-page {
  flex-direction: column;
  height: calc(100vh - 14.453125vh);
  margin-top: 18vh !important;
  overflow-x: auto;

  &__container {
    display: flex;
    flex-direction: column;
    width: 50%;
    min-width: 360px;
    flex-grow: 1;
    margin-top: 20px;
  }

  &__caption {
    text-align: center;
    font-size: 2.9296875vh;
    font-weight: 400;
    margin-bottom: 30px;
  }
}
.button-container {
  margin-top: min(66px, 5.46875vh);
  display: flex;
  align-items: center;
}

.group-param-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button {
  &-confirm,
  &-cancel {
    min-height: 80px;
    border: none;
    background: none;
    font-weight: 600;
    font-size: 24px;
    text-transform: uppercase;
    border-radius: 20px;
  }
  &-confirm {
    box-shadow: 0px 33px 38px rgba(0, 0, 0, 0.0314074),
      0px 12px 12px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.08);
    min-width: 304px;
  }
  &-cancel {
    min-width: 240px;
  }
}
@media screen and (min-height: 1024px) {
  .group-param-page{
    margin-top: 148px;
    height: calc(100vh - 148px);
  }
}
@media screen and (min-height: 1080px) {
  .group-param-page{
    &__caption{
      margin: 24px;
    }
  }
}
</style>
